import React from "react"
import { Datagrid, EditButton, FileField, List, TextField, ImageField } from "react-admin"

export const PartnersList = (props) => {
    return (
        <List {...props}>
            <Datagrid>
                <TextField source="fullName" label="Nom" />
                <ImageField source="logo.src" label="Logo" />
                <EditButton />
            </Datagrid>
        </List>
    )
}
